import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';
import { ContractsService } from '../services/contracts.service';
import { UsersService } from '../services/users.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate, CanActivateChild {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private contractsService: ContractsService,
    private usersService: UsersService
  ) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {

    const loginOidc = localStorage.getItem('oidc-login') ?? undefined;
    if (!loginOidc) {
      return true;
    }
    const isAuthenticated = await firstValueFrom(this.oidcSecurityService.isAuthenticated(loginOidc));
    if (!isAuthenticated) return true;

    const contractsToAccept = await firstValueFrom(this.contractsService.getToAccept());
    const hasContractsToAccept = contractsToAccept && contractsToAccept.length > 0;

    if (hasContractsToAccept) {
      this.router.navigate(['/acceptance'])
      return false
    }

    const userIsHired = await this.usersService.getUserIsHired()

    if (!userIsHired) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }

  async canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return this.canActivate(next, state);
  }
}
